import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

interface ChildFieldsProps {
  index: number;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
}

/**
 * Subcomponente para los campos de cada niño en el formulario Explorer
 */
const ChildFields: React.FC<ChildFieldsProps> = ({ index, register, errors }) => {
  const childErrors = (errors.children as Array<any> | undefined) || [];
  return (
    <div className="mb-4 p-4 rounded-xl bg-yellow-50 bg-opacity-80 border border-yellow-200 mt-2">
      <div className="font-semibold mb-2">Niño {index + 1}</div>
      <div className="flex gap-2 mb-2 flex-col md:flex-row">
        <input
          className="flex-1 p-2 rounded border border-gray-300 focus:outline-none"
          placeholder="Nombre"
          {...register(`children.${index}.name`, { 
            required: 'El nombre del niño es requerido',
            minLength: { value: 2, message: 'El nombre debe tener al menos 2 caracteres' }
          })}
        />
        <input
          className="flex-1 p-2 rounded border border-gray-300 focus:outline-none"
          placeholder="Fecha Nacimiento"
          type="date"
          {...register(`children.${index}.birthdate`, { 
            required: 'La fecha de nacimiento es requerida',
            validate: value => {
              if (!value) return 'La fecha de nacimiento es requerida';
              const birthDate = new Date(value);
              const today = new Date();
              const age = today.getFullYear() - birthDate.getFullYear();
              if (age < 0 || age > 18) {
                return 'La edad debe estar entre 0 y 18 años';
              }
              return true;
            }
          })}
        />
      </div>
      {childErrors[index]?.name && (
        <span className="text-red-500 text-sm">{childErrors[index].name.message}</span>
      )}
      {childErrors[index]?.birthdate && (
        <span className="text-red-500 text-sm">{childErrors[index].birthdate.message}</span>
      )}
    </div>
  );
};

export default ChildFields; 